import React, { useState } from 'react';
import { Carousel } from 'tradera/components/carousel/carousel';
import {
    LeftButton,
    RightButton
} from 'tradera/components/carousel/carousel-buttons';
import { CarouselContent } from 'tradera/components/carousel/carousel-content';
import { CategoryLink } from './category-link';
import useIsMobile from 'tradera/hooks/use-is-mobile';
import { StartPageSection } from '../start-page-section/start-page-section';
import { StartPageSectionTitle } from '../start-page-section/start-page-section-title';

type CategoryLinksItem = {
    categoryId: number;
    title: string;
    webpageUrl: string;
};
export type CategoryLinksData = { title: string; items: CategoryLinksItem[] };
type CategoryLinksProps = { data: CategoryLinksData };

export const CategoryLinks = ({ data }: CategoryLinksProps) => {
    const isMobile = useIsMobile();
    const [width, setWidth] = useState(0);

    return (
        <StartPageSection>
            {data.title && (
                <StartPageSectionTitle>{data.title}</StartPageSectionTitle>
            )}
            <Carousel
                numberItemsToScroll={5}
                className="mx-2 mx-md-3 mx-lg-2 mx-xl-0"
                gap={isMobile ? '0.5rem' : '2rem'}
                showScrollbar={isMobile}>
                <LeftButton light />
                <CarouselContent className="d-flex">
                    {data.items.map((item) => {
                        return (
                            <CategoryLink
                                key={item.categoryId}
                                href={item.webpageUrl}
                                categoryId={item.categoryId}
                                title={item.title}
                                setWidth={setWidth}
                                width={width}
                            />
                        );
                    })}
                </CarouselContent>
                <RightButton light />
            </Carousel>
        </StartPageSection>
    );
};
